import React from 'react';

import { useDroppable } from '@dnd-kit/core';

const Droppable = ({ id, children }) => {
  const { isOver, setNodeRef } = useDroppable({
    id,
  });
  const style = {
    backgroundColor: isOver ? 'rgba(184,184,184,0.5)' : 'rgba(184,184,184,0.2)',
  };

  return (
    <div
      ref={setNodeRef}
      style={{
        minHeight: 200,
        padding: 10,
        ...style,
      }}
    >
      {children}
    </div>
  );
};

export default Droppable;
